import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { Button, Loading, Calendar, Field, Image, Divider, Sticky, Dialog, Stepper, Toast, Lazyload, Tab, Tabs, Tabbar, Collapse, TabbarItem, Form, Cell, CellGroup, Popup, DatetimePicker, Picker, Switch, Icon, CollapseItem, ActionSheet, Search, List, Checkbox, CheckboxGroup, Skeleton, Empty, Overlay, ActionBar, NumberKeyboard, NavBar, Tag } from 'vant';

const app = createApp(App);

app.use(store);
app.use(router);
app.use(NavBar);
app.use(NumberKeyboard);
app.use(Tabbar);
app.use(TabbarItem);
app.use(Button);
app.use(Loading);
app.use(Calendar);
app.use(Field);
app.use(Image);
app.use(Divider);
app.use(Sticky);
app.use(Form);
app.use(Popup);
app.use(DatetimePicker);
app.use(Picker);
app.use(Switch);
app.use(Cell);
app.use(CellGroup);
app.use(Toast);
app.use(Icon);
app.use(Lazyload);
app.use(ActionSheet);
app.use(ActionBar);
app.use(Search);
app.use(List);
app.use(Stepper);
app.use(Tab);
app.use(Tabs);
app.use(Collapse);
app.use(CollapseItem);
app.use(Dialog);
app.use(Checkbox);
app.use(CheckboxGroup);
app.use(Skeleton);
app.use(Empty);
app.use(Overlay);
app.use(Tag);
app.mount('#app');

if (process.env.VUE_APP_CURRENTMODE !== 'production') {
    (function () {
        const script = document.createElement('script');
        script.src = '/eruda.js';
        document.body.appendChild(script);
        script.onload = function () {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            eruda && eruda.init();
        };
    })();
}
